import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TaxService {
  private baseRoute: string;
  private accountBaseRoute: string;

  constructor(private httpClient: HttpClient) {
    this.baseRoute = environment.accountAPIRoot;
    this.accountBaseRoute = environment.accountAPIRoot;
  }

  getAllTaxCategory<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/taxcategory/getall`);
  }

  getTaxSettings<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/taxsettings/get`);
  }

  updateTaxSettings(payload: any) {
    return this.httpClient.post(
      `${this.baseRoute}/taxsettings/update`,
      payload
    );
  }

  getAllManualTax<T>() {
    return this.httpClient.get<T>(
      `${environment.apiRoot}api/account/tax/getall`
    );
  }

  getAllManualTaxById<T>(id: any) {
    return this.httpClient.get<T>(
      `${environment.apiRoot}api/account/tax/get/${id}`
    );
  }

  updateManualTax(payload: any) {
    return this.httpClient.post(
      `${environment.apiRoot}api/account/tax/update`,
      payload
    );
  }

  addManualTax(payload: any) {
    return this.httpClient.post(
      `${environment.apiRoot}api/account/tax/add`,
      payload
    );
  }

  getTaxSummary<T>() {
    return this.httpClient.get<T>(
      `${environment.apiRoot}api/account/taxsummaryrate/getall`
    );
  }

  addTaxSummary(payload: any) {
    return this.httpClient.post(
      `${environment.apiRoot}api/account/taxsummaryrate/add`,
      payload
    );
  }

  updateTaxSummary(payload: any) {
    return this.httpClient.post(
      `${environment.apiRoot}api/account/taxsummaryrate/update`,
      payload
    );
  }

  getAllCountries<T>(): Observable<T> {
    return this.httpClient.get<T>(
      `${environment.locationAPIRoot}/getCountries`
    );
  }

  getTaxJarRate(payload: any) {
    return this.httpClient.post(
      `${environment.apiRoot}api/account/taxjar/tax/order/get`,
      payload
    );
  }

  getManualTax<T>(locationId: number): Observable<T> {
    return this.httpClient.get<T>(
      `${this.baseRoute}/tax/location/get?locationId=${locationId}`
    );
  }

  getAllTaxjarCategory<T>(): Observable<T> {
    return this.httpClient.get<T>(
      `${this.baseRoute}/taxcategory/taxjar/getall`
    );
  }
}
